import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import VerificationPage from "../../../components/VerificationPage";
import { registerWorker } from "../../../services/worker/authenticationApiFn";
import { encryptPassword, handleOpenSnackBar } from "../../../utils";
import { companySendCode } from "../../../services/company/authenticationApiFn";

const WorkerRegistrationVerification = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { inputValues } = state;
  const [code, setCode] = useState();
  const [isLoading, setIsLoading] = useState("");

  const handleVerify = async () => {
    const longitude = inputValues.workerLocation?.lng;
    const latitude = inputValues.workerLocation?.lat;

    const locationObject = {
      addressLabel: inputValues.location.label,
      formatedAddress: inputValues?.workerLocation?.address,
      type: "Point",
      coordinates: [longitude, latitude],
    };

    const payload = {
      name: inputValues.name,
      email: inputValues.email,
      contact: inputValues.contact,
      location: locationObject,
      country: "Romania",
      city: inputValues.city,
      state: inputValues.state,
      companyId: inputValues.company,
      profileImg: inputValues.image,
      gender: inputValues.gender,
      expertise: inputValues.expertise,
      backgroundImages: inputValues.workerBgImages,
      services: state?.services,
      password: encryptPassword(inputValues.password),
      role: "Worker",
      otp: code,
    };

    try {
      setIsLoading(true);
      const response = await registerWorker(payload);
      if (response.data.status === "success") {
        const data = response.data.data;
        navigate("/subscriptions", {
          state: { type: "worker", user: data?._id, subscriptionId: "" },
        });
        // navigate("/login", {
        //   state: { type: "worker" },
        // });
        setCode("");
        handleOpenSnackBar("success", response?.data?.message);
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSendCode = async () => {
    try {
      setIsLoading(true);
      const payload = {
        email: inputValues.email,
        purpose: "Registration",
        role: "Worker",
      };
      const response = await companySendCode(payload);
      if (response.data.status === "success") {
        handleOpenSnackBar("success", response?.data?.message);
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <VerificationPage
      handleBack={() => {
        navigate("/register/worker", {
          state: { inputValues, selectedServices: state?.services },
        });
      }}
      code={code}
      setCode={setCode}
      handleClickBtn={handleVerify}
      isLoading={isLoading}
      handleSendCode={handleSendCode}
    />
  );
};

export default WorkerRegistrationVerification;
